import { collection, deleteDoc, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { db } from "../firebase";

// Fiche publique des professeurs (RGPD) : la collection `users` contient l'e-mail,
// la date de naissance et le solde, elle n'est donc plus lisible par le public.
// Les pages publiques lisent `publicProfiles/{uid}`, qui ne contient que ceci :
const PUBLIC_FIELDS = ["firstName", "lastName", "description", "profilePicture"];

const pick = (data) => {
  const out = {};
  PUBLIC_FIELDS.forEach((k) => {
    out[k] = typeof data?.[k] === "string" ? data[k] : "";
  });
  return out;
};

/**
 * Met la fiche publique en accord avec le profil : créée ou mise à jour pour un
 * prof (role 1), supprimée sinon. N'écrit que si quelque chose a changé.
 */
export const syncPublicProfile = async (uid, profile) => {
  if (!uid || !profile) return;
  const ref = doc(db, "publicProfiles", uid);
  const snap = await getDoc(ref);
  if (profile.role === 1) {
    const next = pick(profile);
    const current = snap.exists() ? pick(snap.data()) : null;
    if (!current || PUBLIC_FIELDS.some((k) => current[k] !== next[k])) {
      await setDoc(ref, next);
    }
  } else if (snap.exists()) {
    await deleteDoc(ref);
  }
};

export const removePublicProfile = (uid) => deleteDoc(doc(db, "publicProfiles", uid));

/** Tous les profs (fiches publiques), avec `id` = uid */
export const getPublicTeachers = async () => {
  const snap = await getDocs(collection(db, "publicProfiles"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

/** Fiche publique d'un prof, ou null */
export const getPublicTeacher = async (uid) => {
  const snap = await getDoc(doc(db, "publicProfiles", uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};
